export default __webpack_public_path__ + "static/media/noise.d8b6cff9.png";